<template lang="pug">
  .body.form-user
    .header
      h1.title.u-text-width-bold(v-html="$t('auth.msg.register_form_user_title')")

    .content

      form.form(data-vv-scope="user")

        .row
          .line-form-container.inline(
          :class="[{ 'is-danger': veeErrors.has('user.first_name') }, { 'filled' : form.first_name }]")
            label.line-form-label
              | {{$t('generic.field.name')}}
            input.line-form-control(
            name="first_name"
            autocomplete="first_name"
            type="text"
            v-model="form.first_name"
            :data-vv-as="$t('generic.field.name')"
            v-validate="'required|max:128'"
            )

          .line-form-container.inline(
          :class="[{ 'is-danger': veeErrors.has('user.last_name') }, { 'filled' : form.last_name }]")
            label.line-form-label
              | {{$t('generic.field.surname')}}
            input.line-form-control(
            name="last_name"
            autocomplete="last_name"
            type="text"
            v-model="form.last_name"
            :data-vv-as="$t('generic.field.surname')"
            v-validate="'required|max:128'"
            )          

        .row
          .line-form-container.inline(
          :class="[{ 'is-danger': veeErrors.has('user.email') }, { 'filled' : form.email }]")
            label.line-form-label
              | {{$t('generic.field.email')}}
            input.line-form-control(
            name="email"
            autocomplete="email"
            type="email"
            v-model="form.email"
            :data-vv-as="$t('generic.field.email')"
            v-validate="'required|max:128'"
            )

          .line-form-container.inline.password(
          :class="[{ 'is-danger': veeErrors.has('user.password') }, { 'filled' : form.password }]")
            label.line-form-label
              | {{$t('generic.field.password')}}
            input.line-form-control(
            name="password"
            autocomplete="current-password"
            :type="password_type"
            v-model="form.password"
            :data-vv-as="$t('generic.field.password')"
            v-validate="'required|min:6|max:128'")
            button.show-toggle.btn.btn-icon(
            type="button" @click="showPassword")
              IconEyeOff(v-if="password_type === 'password'")
              IconEye(v-else)

       
        .row.submit
          button.btn.btn-primary(
          type="button"
          @click="$emit('onNext')")
            | {{$t('generic.action.continue')}}

    .footer.user
      p
        | {{ $t('auth.msg.still_have_account') + ' ' }}
        router-link.u-color-blue(:to="{ name: 'login' }") {{$t('auth.action.log_in')}}

</template>

<script>
  export default {
    name: 'register-form-user',

    props: [
      'form'
    ],

    data () {
      return {
        typePassword: false
      }
    },

    computed: {

      password_type () {
        return this.typePassword ? 'text' : 'password'
      }

    },

    methods: {

      showPassword () {
        this.typePassword = !this.typePassword
      }

    }

  }
</script>
